import styled from 'styled-components';

export const BadgeWrapper = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: ${({ theme }) => theme['white-color']};
  padding: 0.5px 8px;
  border-radius: 2px;
  text-transform: capitalize;
  background-color: ${({ status, theme }) => {
    switch (status?.toLowerCase()) {
      case 'confirmed':
        return theme['primary-color'];
      case 'completed':
        return theme['green-color'];
      case 'arrived':
        return theme['green-color'];
        case 'deleted':
        return theme['red-color']
      case 'receiving':
        return theme['receiving-color'];
      case 'received':
        return theme['green-color'];
      case 'processed':
        return theme['processed-color'];
      case 'in progress':
        return theme['warning-color'];
      case 'done':
        return theme['success-color'];
      case 'pending':
        return 'Orange';
      case 'draft':
        return theme['uniform-gray-color'];
      default:
        return 'gray';
    }
  }};
`;
export const CircleBadgeWrapper = styled.div`
  padding: 6px 12px;
  background-color: ${({ status }) => {
    switch (status?.toLowerCase()) {
      case 'confirmed':
        return 'rgba(21, 101, 216, 0.2)';
        case 'arrived':
        return 'rgba(82, 196, 26, 0.1)';
      case 'receiving':
         // return 'rgba(250, 173, 20, 0.1)';
        return '#47B5FF33';
      case 'received':
        return 'rgba(82, 196, 26, 0.1)';
      case 'processed':
        return '#9747FF33';
      case 'in progress':
        return 'rgba(255, 153, 0, 0.2)'
      case 'done':
        return 'rgba(0, 156, 52, 0.2)'
      case 'pending':
        return '#ffa5033d';
      case 'draft':
        return 'rgba(168, 168, 168, 0.2)';
      default:
        return 'gray';
    }
  }};
  grid-gap: 8px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color: ${({ theme }) => theme['label-color-new']};
    text-transform: capitalize;
  }
  span.circle {
    width: 12px;
    height: 12px;
    border-radius: 60px;
    background-color: ${({ status, theme }) => {
      switch (status?.toLowerCase()) {
        case 'confirmed':
          return theme['primary-color'];
        case 'arrived':
          return theme['green-color'];
        case 'receiving':
          return theme['receiving-color'];
        case 'received':
          return theme['green-color'];
        case 'processed':
          return theme['processed-color'];
        case 'in progress':
          return theme['warning-color'];
        case 'done':
          return theme['success-color'];
        case 'pending':
          return theme['orange-color'];
        case 'draft':
         return theme['uniform-gray-color'];;
        default:
          return 'gray';
      }
    }};
  }
`;
export const SimpleTextBadgeWrapper = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: ${({ status, theme }) => {
    switch (status) {
      case 'Confirmed':
        return theme['primary-color'];
      case 'Arrived':
        return theme['green-color'];
      case 'Receiving':
        return theme['orange-color'];
      case 'Received':
        return theme['green-color'];
      case 'Processed':
        return theme['sky-blue-color'];
      case 'In Progress':
        return theme['warning-color'];
      case 'done':
        return theme['success-color'];
      case 'Pending':
        return 'Orange';
      case 'draft':
        return theme['uniform-gray-color'];
      default:
        return 'gray';
    }
  }};
  text-transform: capitalize;
`;
